import type { Permission } from '@/shared/constants';
import type { ApiPermissionsResponse, PermissionItem } from '../api/types';

/**
 * Per-item allow/deny predicate.
 *
 * | type      | allow rule                |
 * |-----------|---------------------------|
 * | 'basic'   | item.company && item.role |
 * | 'premium' | item.addon   && item.role |
 * | ''        | item.role                 |
 *
 * Exported for reuse in tests and future `usePermissionItem`.
 */
export const isAllowed = (item: PermissionItem): boolean => {
	switch (item.type) {
		case 'basic':
			return item.company && item.role;
		case 'premium':
			return item.addon && item.role;
		case '':
			return item.role;
	}
};

export const resolvePermissions = (data: ApiPermissionsResponse): Set<Permission> => {
	const enabled = data.filter(isAllowed).map((item) => item.permission);
	return new Set(enabled.sort() as Permission[]);
};
